var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { FeatureAppLoader } from '@feature-hub/react';
/**
 * @description Opens the config assistant in a layer to resolve a conflict
 * @param language language from the local service
 * @param countryCode country code from the local service
 * @param market market from the local service
 * @param layerManager layer manager from the layer manager service
 * @param conflict conflict to be solved
 * @param action action which triggered the conflict
 * @param initialCarId Car id of the car to be configured
 * @param acceptConflictSolution function to set the conflict solution after resolving the conflict
 * @returns void
 */
export var openConfigAssistant = function (layerManager, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
conflictResponse, action, initialCarId, configAssistantVersion, financingInput, acceptConflictSolutions) { return __awaiter(void 0, void 0, void 0, function () {
    var conflict, sideEffects;
    return __generator(this, function (_a) {
        conflict = conflictResponse.conflict, sideEffects = conflictResponse.sideEffects;
        layerManager.openFocusLayer(function (_a, close) {
            var carId = _a.carId;
            return (React.createElement(FeatureAppLoader, { featureAppId: "fa-config-assistant", src: "https://fa-config-assistant.cdn.prod.arcade.apps.one.audi/".concat(configAssistantVersion, "/fh/app.js"), config: {
                    conflict: conflict,
                    transfer: sideEffects,
                    action: action,
                    layerHandle: { close: close },
                    initialCarId: carId,
                    financingInput: financingInput,
                } }));
        }, { carId: initialCarId }, {
            size: "A" /* FocusLayerSizeV2.A */,
            userCloseable: true,
            onClose: function (state, response) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                if (response) {
                    if (!response.carId)
                        return;
                    var newCarId = {
                        model: {
                            code: (_a = response === null || response === void 0 ? void 0 : response.carId.model) === null || _a === void 0 ? void 0 : _a.code,
                            extensions: (_c = (_b = response.carId) === null || _b === void 0 ? void 0 : _b.model) === null || _c === void 0 ? void 0 : _c.extensions,
                            version: (_e = (_d = response.carId) === null || _d === void 0 ? void 0 : _d.model) === null || _e === void 0 ? void 0 : _e.version,
                            year: (_g = (_f = response.carId) === null || _f === void 0 ? void 0 : _f.model) === null || _g === void 0 ? void 0 : _g.year,
                        },
                        brand: (_h = response.carId) === null || _h === void 0 ? void 0 : _h.brand,
                        country: (_j = response.carId) === null || _j === void 0 ? void 0 : _j.country,
                        language: (_k = response.carId) === null || _k === void 0 ? void 0 : _k.language,
                        equipmentOptions: (_l = response.carId) === null || _l === void 0 ? void 0 : _l.equipmentOptions,
                        exteriorColor: (_m = response.carId) === null || _m === void 0 ? void 0 : _m.exteriorColor,
                        interiorColor: (_o = response.carId) === null || _o === void 0 ? void 0 : _o.interiorColor,
                        salesGroup: (_p = response.carId) === null || _p === void 0 ? void 0 : _p.salesGroup,
                    };
                    acceptConflictSolutions(newCarId);
                }
                else {
                    acceptConflictSolutions(initialCarId);
                }
            },
        });
        return [2 /*return*/];
    });
}); };
//# sourceMappingURL=open-config-assistant.js.map